import React, { useEffect, useState } from "react";
import Select from 'react-select';
import Dropdown from 'react-bootstrap/Dropdown';
import { getUser, getLoggedInUserOffices } from "../../utility/Auth"
import {
  GetOfficesList
} from "../../utility/Form";
import { isEmpty } from 'lodash';

const SearchComp = (props) => {
  const [loginUser, setLoginUser] = useState(getUser());
  const [loggedInUserOffices, setLoginUserOffices] = useState(getLoggedInUserOffices());
  const [offices, setOffices] = useState([]);
  const [minPrice, setMinPrice] = useState(0);
  const [maxPrice, setMaxPrice] = useState(0);
  const GetOffices = async () => {
    try {
      const myHomeIds = loginUser.hasSuperAdminRole ? null
        : loggedInUserOffices.map((element) => element['my_home_id']);
      const data = await GetOfficesList(myHomeIds);
      setOffices(data.map(office => {
        return {
          value: office['my_home_id'],
          label: `${office['Office_Name']} ${office['Branch_Location'] ? (`(${office['Branch_Location']})`) : ""}`,
          isDisabled: (!office.Publish) || isEmpty(office.published_at) || (!office['my_home_id'])
        }
      }));
    } catch (error) {
      console.log('SearchComp GetOffices error', error);
    }
  };
  useEffect(() => {
    GetOffices();
  }, []);
  const filterNumber = (str) => {
    if (!str) return 0
    str = str.toString()
    return parseInt(str.replace(/[^\d.]/g, ""), 10)
  }
  const numberFormat = num => { 
    if (!num) return 0
    return new Intl.NumberFormat("en-US", {}).format(filterNumber(num))
  }

  
  return (
    <>
      <li className="list-inline-item drop_down col-3 department-list">
        <Select
          name="office"
          options={offices}
          classNamePrefix="react2-select"
          placeholder="Offices"
          isSearchable={true}
          className="secondary-classname"
          isMulti={true}
          onChange={(event) => props.handleSearchChange(event, 'office_crm_id')}
        />
      </li>
      <li className="list-inline-item drop_down col-3 department-list">
        <Select
          options={[
            { value: "residential", label: "Residential" },
            { value: "commercial", label: "Commercial" },
            { value: "new_developments_residential", label: "New Developments" },
          ]}
          classNamePrefix="react2-select"
          placeholder="Department"
          isSearchable={true}
          className="secondary-classname"
          isMulti={true}
          onChange={(event) => props.handleSearchChange(event, 'department')}
        />
      </li>
      <li className="list-inline-item drop_down col-3 department-list">
        <Select
          options={[
            { value: "sales", label: "Sales" },
            { value: "lettings", label: "Lettings" },
          ]}
          classNamePrefix="react2-select"
          placeholder="Type"
          isSearchable={true}
          className="secondary-classname"
          isMulti={true}
          onChange={(event) => props.handleSearchChange(event, 'search_type')}
        />
      </li>
      <li className="list-inline-item drop_down col-3 department-list">
        <Select
          name="status"
          options={[
            { value: "Exchanged", label: "Exchanged" },
            { value: "For Sale", label: "For Sale" },
            { value: "Sold", label: "Sold" },
            { value: "Sale Agreed", label: "Sale Agreed" },
            { value: "Let", label: "Let" },
            { value: "Let Agreed", label: "Let Agreed" },
            { value: "PostPoned", label: "PostPoned" },
            { value: "To Let", label: "To Let" },
            { value: "Withdrawn", label: "Withdrawn" },
          ]}
          classNamePrefix="react2-select"
          placeholder="Status"
          isSearchable={true}
          className="secondary-classname"
          isMulti={true}
          onChange={(event) => props.handleSearchChange(event, 'status')}
        />
      </li>
      <li className="list-inline-item drop_down col-3 department-list">
        <Select
          name="published_at_null"
          options={[{value: true, label: 'Draft'}, {value: false, label: 'Published'}]}
          classNamePrefix="react2-select"
          placeholder="Publication Status"
          isSearchable={true}
          className="secondary-classname"
          isMulti={true}
          onChange={(event) => props.handleSearchChange(event, 'published_at_null')}
        />
      </li>
      <Dropdown className="d-inline mx-2 minmax-dropdown" autoClose="outside">
        <Dropdown.Toggle id="dropdown-autoclose-outside">
          Min - Max Price
        </Dropdown.Toggle>
        <Dropdown.Menu>
          <Dropdown.Item as="list">
          <span className="currency">€</span>
            <input className="form-control"
              name="price_gte"
              placeholder="Min Price" 
              value={numberFormat(minPrice)}
              onChange={(event) => {
                setMinPrice(event.target.value)
                props.handleTextChange(event, { type: 'float' })
              }} />
          </Dropdown.Item>
          <Dropdown.Item as="list">
          <span className="currency">€</span>
            <input className="form-control"
              name="price_lte"
              placeholder="Max Price"
              value={numberFormat(maxPrice)}
              onChange={(event) => {
                setMaxPrice(event.target.value)
                props.handleTextChange(event, { type: 'float' })
              }}
               />
          </Dropdown.Item>
        </Dropdown.Menu>
      </Dropdown>
    </>
  )
}

export default SearchComp;
